import { API_AUTH } from "../common";

const LoiNhuanBanHangApi = {

  getData: ({
    SearchText,
    SoSanh,
    LoiNhuanSS,
    DateFrom,
    DateTo,
    pageIndex,
    pageSize
  }) =>
    API_AUTH.get(
      `QuanLyMuaBan/LoiNhuanBanHang/GetDanhSach?SearchText=${SearchText}&SoSanh=${SoSanh}&LoiNhuanSS=${LoiNhuanSS}&DateFrom=${DateFrom}&DateTo=${DateTo}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),

  updateDaXem: (orderID, taiSanID) => API_AUTH.post(`QuanLyMuaBan/LoiNhuanBanHang/UpdateDaXem?orderID=${orderID}&taiSanID=${taiSanID}`),
  
}
export default LoiNhuanBanHangApi;